﻿class ConfigPropMapService {
    static getConfigPropbyId(configPropId) {

        var configPropList = reactConfigObject.configPropValues;
        if (configPropList.length > 0) {
            var index = configPropList
                .map(configProp => {
                    return configProp.id;
                }).indexOf(configPropId);

            return configPropList[index];
        }
    }
}

export default ConfigPropMapService;